// Merkan · Hinweisleiste KI-Kontingent auf jeder Seite (DB-06)
// Sichtbar mit Recht ki.verbrauch.sehen, sobald höchstens 20 % des Monatskontingents frei sind. Link zur Aufschlüsselung.
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { supabase } from '../../lib/supabase';
import { useSession } from '../../lib/session';
import { datum } from '../../lib/format';
import { t } from '../../lib/sprache';
import './bn.css';

interface Stand { kontingent: number; verbraucht: number; bis: string; verhalten: 'stopp' | 'weiter'; modul_aktiv: boolean }

export default function KiHinweis() {
  const { hat, mandant } = useSession();
  const mandantId = mandant?.mandant_id ?? null;
  const darf = hat('ki.verbrauch.sehen');
  const ort = useLocation();
  const [stand, setStand] = useState<Stand | null>(null);

  useEffect(() => {
    if (!darf || !mandantId) { setStand(null); return; }
    let aktiv = true;
    const laden = () => supabase.rpc('ki_stand', { p_mandant: mandantId }).then(({ data, error }) => { if (aktiv && !error) setStand(data as Stand | null); });
    void laden();
    const takt = window.setInterval(() => void laden(), 5 * 60_000);
    return () => { aktiv = false; window.clearInterval(takt); };
  }, [darf, mandantId]);

  if (!darf || !stand || !stand.modul_aktiv) return null;
  const kontingent = Number(stand.kontingent) || 0;
  if (kontingent <= 0) return null;
  const anteil = Math.min(1, (Number(stand.verbraucht) || 0) / kontingent);
  const rest = 1 - anteil;
  if (rest > 0.2) return null;
  const aufSeite = ort.pathname.startsWith('/einstellungen/ki');
  const leer = rest <= 0;
  const text = leer
    ? (stand.verhalten === 'stopp'
      ? t('KI-Kontingent aufgebraucht. Die KI-Funktionen sind bis zum Monatsersten angehalten.')
      : t('KI-Kontingent aufgebraucht. Die KI läuft weiter, der Mehrverbrauch wird im Folgemonat abgerechnet.'))
    : t('KI-Kontingent: nur noch {n} % frei bis {datum}.', { n: Math.round(rest * 100), datum: datum(stand.bis) });

  return (
    <div className="bn-leiste nicht-drucken" role="status" data-tour="ki-hinweisleiste">
      <AlertTriangle aria-hidden="true" />
      <span className="bn-leiste-text">{text}</span>
      {!aufSeite && <Link to="/einstellungen/ki">{t('Verbrauch ansehen')}</Link>}
    </div>
  );
}
